"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var SortableRow = _styledComponents["default"].tr(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    cursor: grab;\n\n    &:active {\n        cursor: grabbing;\n    }\n\n    &.sortable-chosen {\n        background-color: #ffffff;\n        opacity: 0.7;\n    }\n\n    &.sortable-ghost {\n        background-color: ", ";\n        color: ", ";\n        .btn {\n            opacity: 0;\n        }\n    }\n\n    td {\n        vertical-align: middle;\n    }\n"])), function (props) {
  return props.theme.admin.colors.background;
}, function (props) {
  return props.theme.admin.colors.background;
});

var _default = SortableRow;
exports["default"] = _default;